import React, { Component } from 'react';
import Helmet               from "react-helmet";
import { googleMapUrl }     from './../../classes/Config';
import { getBodyStyle }     from './../../css/Styles';

class AppHeader extends Component
{

    /**
     * When the Google API js is added to the header, register it with the redux store.
     *
     * There has been a race condition where the window.google object was not ready by the
     * time a component map required it.  Google is not registered until we know it is
     * available.
     *
     * @param newState
     */
    handleOnHeaderChange = (newState) =>
    {
        if (1 === newState.scriptTags.length)
        {
            let script = newState.scriptTags[0].src;
            if (script.indexOf('google'))
            {
                if (typeof window.google === 'undefined')
                {
                    let intId = setInterval(() =>
                    {
                        if (typeof window.google !== 'undefined')
                        {
                            this.props.registerGoogle();
                            clearInterval(intId);
                        }
                    }, 100);
                }
                else
                {
                    this.props.registerGoogle();
                }
            }
        }
    };

    render = () => {
        return (
            <Helmet
                script={[
                        {"src": googleMapUrl, "type": "text/javascript"}
                    ]}
                style={[
                        {"type": "text/css", "cssText": getBodyStyle(this.props.theme) }
                    ]}
                onChangeClientState={this.handleOnHeaderChange}
            />
        );
    }

}

export default AppHeader



// WEBPACK FOOTER //
// ./src/components/App/AppHeader.js